import { type StaticImageData } from 'next/image'
import { type FC, type ReactNode } from 'react'

import { StaticImage } from '../../../../../image'

type InfoPointProps = {
  content: ReactNode[]
  image: StaticImageData
  title: string
}

export const RxLpChHowToPoint: FC<InfoPointProps> = (props: InfoPointProps) => {
  const { content, image, title } = props

  return (
    <div className="flex size-full flex-[1-0-0] flex-col items-center gap-4 rounded-2xl bg-light-primary-low p-4">
      <div className="flex items-center justify-center">
        <StaticImage
          alt={title}
          className="tablet:h-36 tablet:w-[162px]"
          height={96}
          src={image}
          width={108}
        />
      </div>
      <div className="flex flex-col items-center gap-6">
        <span className="text-center text-m font-medium">{title}</span>
        <div className="flex flex-col gap-3">
          <span className="text-center text-m">{content[0]}</span>
          <span className="text-center text-m">{content[1]}</span>
        </div>
      </div>
    </div>
  )
}
